export enum ConnectedAccountActivitySourceType {
    Payout = 'payout',
    Conversion = 'conversion',
    Deposit = 'deposit',
    Adjustment = 'adjustment',
    Fee = 'fee',
    PaymentAttempt = 'payment_attempt',
    Refund = 'refund',
    Dispute = 'dispute',
    Charge = 'charge',
    Transfer = 'transfer',
    Yield = 'yield',
    BatchPayout = 'batch_payout',
    CardPurchase = 'card_purchase',
    CardRefund = 'card_refund',
    Purchase = 'purchase',
    RefundReversal = 'refund_reversal',
}
